import React, { Component } from 'react';
import xr from 'xr';
import logo from './logo.png';
import discordImg from './discord.png';
import sha256 from 'js-sha256';
import './App.css';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: null,
      key: null,
    }
  }

  render() {
    const { key, loading, error } = this.state;
    const { code, redeem } = this.props;

    return (
      <div className="App">
        <img src={logo} className="App-logo" alt="logo" />

        { !code && !redeem && <p className="info">
          Daemonical alpha signups are closed at the moment.<br/>
          Make sure to <a href="https://www.google.com/url?q=http://store.steampowered.com/app/779100/Daemonical/&sa=D&source=hangouts&ust=1527238246767000&usg=AFQjCNGrC5dbZ3v5D-aPp5oGZwoIgpXj2Q" target="_blank">wishlist</a> the game to
          keep updated. Thank you for your interest!</p>
        }

        { redeem && !error &&
            <p className="info">Write the e-mail address you used to register for the alpha<br/>in the box below and press the redeem button.</p> }

        { redeem && !error && <input ref={el => this.inputEl = el} className="email" disabled={loading} placeholder="Your e-mail" /> }

        { (code || redeem) && !key && !error &&
          <button onClick={this.redeem} disabled={loading}>
            { !loading ? 'Click here to redeem your Steam key!' : 'Please wait' }
          </button>
        }

        { (code || redeem) && key && <div className="key">Your Steam key is <b>{ key }</b></div> }
        { (code || redeem) && error && <div className="key">{ error }</div> }
        { redeem && <p className="note">
            IMPORTANT: Please note that we are not storing your address anywhere.
            We are just cross referencing it with irreversible encrypted string
            that presents your previously submitted e-mail address.</p> }



        <div className="promo">
          <div>
            <p className="info">
               If you want to  keep receiving keys<br/>and updates from us, sign up here.
            </p>
            <iframe width="540" height="340" src="https://my.sendinblue.com/users/subscribe/js_id/2macu/id/1" frameBorder="0" scrolling="auto" allowFullScreen />
          </div>

          <div>
            <p className="info">
              Come to our <a href="https://discordapp.com/invite/WrAwSte" alt="">Discord server</a>,
              where we will<br/>have regular key giveaways.
            </p>
            <a href="https://discordapp.com/invite/WrAwSte" alt="">
              <img src={discordImg} alt="" width={600} />
            </a>
          </div>
        </div>
      </div>
    );
  }

  getHash = () => {
    let hash = sha256.create();
    hash.update(this.inputEl.value.trim().toLowerCase());
    return hash.hex();
  }

  redeem = () => {
    this.setState({loading: true});

    const url = '/api/steam_key/';

    const data = this.props.redeem ? {hash: this.getHash()} : {code: this.props.code};

    xr.post(url, data)
     .then(resp => {
       setTimeout(() => this.setState({key: resp.data.key}), 1000);
     })
     .catch(err => {
       setTimeout(() => {
         const ERR = 'Unexpected error has happened. Please try again later or contact us on Discord.';

         if (err.status === 400) {
           const data = JSON.parse(err.response);

           if (data.code === 'NO_LINK') {
             if (this.props.redeem) {
               this.setState({error: 'The e-mail is not valid. Please contact us on Discord.'});
             } else {
               this.setState({error: 'The link is not valid. Please contact us on Discord.'});
             }
           } else if (data.code === 'EXPIRED') {
              this.setState({error: 'Your key has expired. The keys last for 90 days.'});
           } else if (data.code === 'NO_KEY') {
              this.setState({error: 'Oh no! We ran out of keys! Please check again later or contact us on Discord.'});
           } else {
              this.setState({error: ERR});
           }
         } else {
          this.setState({error: ERR});
         }
      }, 1000);
     });
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/